import React from 'react';
import ActivitiesCard from './ActivitiesCard';

const ActivitiesList = ({ activities = [] }) => {
  if (activities.length === 0) {
    return <div className="activities-list">No activities to display.</div>;
  }

  return (
    <div className="activities-list grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {activities.map((a, i) => {
        const slugKey = typeof a.slug === 'string'
          ? a.slug
          : a.slug?.current;

        return (
          <ActivitiesCard
            key={slugKey || `activity-${i}`}
            activity={a}
          />
        );
      })}
    </div>
  );
};

export default ActivitiesList;
